import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App';
import * as serviceWorker from './serviceWorker';
import {BrowserRouter} from "react-router-dom";
ReactDOM.render(
    <BrowserRouter>
        <App />  {/* Your main app component */}
    </BrowserRouter>,
    document.getElementById('root')
);


// PWA: service worker (production) — cache statiky a offline náhrada pro navigaci.
serviceWorker.register();
